declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

export const env = {
  REACT_APP_API_URL: window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000',
  REACT_APP_GENERATE_AGENT_CREW_ID_DEV: window._env_?.REACT_APP_GENERATE_AGENT_CREW_ID_DEV || process.env.REACT_APP_GENERATE_AGENT_CREW_ID_DEV || '',
  REACT_APP_GENERATE_AGENT_CREW_ID_PROD: window._env_?.REACT_APP_GENERATE_AGENT_CREW_ID_PROD || process.env.REACT_APP_GENERATE_AGENT_CREW_ID_PROD || '',
  REACT_APP_GENERATE_TASK_CREW_ID_DEV: window._env_?.REACT_APP_GENERATE_TASK_CREW_ID_DEV || process.env.REACT_APP_GENERATE_TASK_CREW_ID_DEV || '',
  REACT_APP_GENERATE_TASK_CREW_ID_PROD: window._env_?.REACT_APP_GENERATE_TASK_CREW_ID_PROD || process.env.REACT_APP_GENERATE_TASK_CREW_ID_PROD || '',
  REACT_APP_STRIPE_TEST_MODE: window._env_?.REACT_APP_STRIPE_TEST_MODE || process.env.REACT_APP_STRIPE_TEST_MODE || '',
};
